module.exports = __webpack_public_path__ + "static/media/result_logo.17115cda.png";